import copy from "fast-copy";

/**Add commentMore actions
 * This function is used to make an object mutable
 */
export const makeMutable = <T>(obj: T): DeepWriteable<T> => {
	return obj as DeepWriteable<T>;
};

/**
 * This function is used to make an object mutable and copy it
 */
export const makeMutableCopy = <T>(obj: T): DeepWriteable<T> => {
	return copy(obj) as DeepWriteable<T>;
};

/**
 * This function is used to make an object immutable
 */
export const makeImmutable = <T>(obj: T): Readonly<T> => {
	return obj as Readonly<T>;
};

/**
 * This function is used to make an object immutable and copy it
 */
export const makeImmutableCopy = <T>(obj: T): Readonly<T> => {
	return copy(obj) as Readonly<T>;
};
